import { ChevronRightIcon } from '@chakra-ui/icons';
import {
    AspectRatio,
    Badge,
    Box,
    Flex,
    Center,
    IconButton,
    Circle,
    Image,
    Skeleton,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Container,
    Heading,
    HStack,
    FormControl,
    FormLabel,
    Stack,
    Text,
    useBreakpointValue,
    useColorModeValue,
    useControllableState,
    useColorModeValue as mode,
    Button,
    Icon,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
    ButtonGroup,
    Input,
    SimpleGrid,
    Divider,
    useToast,
    Spinner,
} from '@chakra-ui/react';
import { useKeenSlider } from 'keen-slider/react'
import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { Link, NavLink, useParams, useSearchParams } from 'react-router-dom';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';
import { FiClock, FiDownload, FiEdit, FiEye, FiHeart, FiMinus, FiPlus, FiTrash } from 'react-icons/fi';
import { FaFacebookSquare, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';
import { RiRulerLine } from "react-icons/ri";
import { getBrowserName } from "../../Utils/BrowserName";
import { getNetworksConnection } from "../../Utils/Network";

import { db } from '../config/firebase';
import axios from 'axios';
import moment from 'moment/moment';
import { createInvoice } from '../api/xendit';
import Cookies from "js-cookie";
import ApiEncrypt from "./../api/apiEncrypted";
import ProductVariant from './ProductVariant';
import ProductDimension from './ProductDimension';

function myNetwork(callback){
    const getNetwork=getNetworksConnection();
      return Promise.all([getNetwork]).then((values)=>{
        return callback(values[0]['data']);
      })
  }

function pageViewBy(product,productId){
    const userData=Cookies.get("uuid");
    const expiredDate= Cookies.get("expired_date");
    const userID= Cookies.get("uid");

    let responseData= [];
        const result=myNetwork(function(values) {
            responseData.push(values);
          }).finally(()=>{
          //start tracking
          const appId=product['appId'];
          const token=product['appKey'];
          let data=JSON.stringify({
            "app_id": appId,
            "track": "ViewContent",
            "pathname": window.location.pathname,
            "browser": getBrowserName(),
            "userAgent": window.navigator.userAgent,
            "type": null,
            "data": JSON.stringify(product),
            "href": window.location.href,
            "origin": window.location.origin,
            "hostname": window.location.hostname,
            "element": null,
            "host": window.location.host,
            "search": "",
            "query": "track=ViewContent",
            "network": responseData[0]['ip'],
            "networkisp": responseData[0]['isp'],
            "latitude": responseData[0]['latitude'],
            "longitude": responseData[0]['lognitude'],
            "custom" : "",
            "uid" : userData,
            "expired_date" : expiredDate,
            "affiliator_id" : userID
        });
    
        var config = {
          method: 'post',
          url: `${process.env.REACT_APP_TRACKER_BASEURL}/data/${appId}`,
          headers: { 
            'Authorization': token, 
            'Content-Type': 'application/json'
          },
          data : data
        };

        axios(config).then((response)=>{
            console.log('done!!');
        })
        //end tracking          
          });
          //code   
}

function ProductPage() {

    const toast = useToast()
    const [product, setProduct] = useState("");
    const [productImg, setProductImg] = useState([]);
    const [affiliator, setAffiliator] = useState("");

    const [isSubmited, setIsSubmited] = useState(false);

    const [customerName, setCustomerName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");

    const [value, setValue] = useControllableState({
        defaultValue: 1,
    })

    const [isImageLoading, setIsImageLoading] = useState(true);
    const [isProduct, setIsProduct] = useState(false);
    const [isBrand, setIsBrand] = useState(false);
    const [isAffiliator, setIsAffiliator] = useState(false);
    const [loading, setLoading] = useState(true);

    const param = useParams();
    const [searchParams] = useSearchParams();

    const productId = param.id;
    const brandId = searchParams.get('brand');
    const affiliatorId = searchParams.get('ref');


const handlingCookie=()=>{
    const docId=`${productId}-${affiliatorId}`;
    const _q = getDoc(doc(db,'generate_link',docId)).then((values)=>{
        const data=values.data();
        const dateStr=new Date(data['expired_date']);
        const RemoveFirst=Cookies.remove("expired_date",{ expires: "", path:"" });
        const userData=Cookies.set("expired_date",data['expired_date'],{ expires: dateStr, path: data['link'], secure: true,sameSite: 'none' });
        const userID=Cookies.set("uid",data['affiliator_id'],{ expires: dateStr, path: data['link'], secure: true,sameSite: 'none' });
    })
}    


useEffect(() => {
    handlingCookie();
}, [])


    const handleGetProductData = async () => {
        const productRef = doc(db, `products`, productId);
        const productSnap = await getDoc(productRef);
        if (productSnap.exists()) {
            setProduct(productSnap.data());
            setIsProduct(true);

            let y = [];
            productSnap.data().productImages.map((item, index) => {
                y.push({ id: index, src: item.url, alt: item.path });
            })
            setProductImg(y);
            // console.log(y, "y");
            setIsImageLoading(false);
            if (productSnap.data().brandId === brandId) {
                setIsBrand(true);
            } else {
                setIsBrand(false);
                console.log("Brand ID does not match");
            }
            pageViewBy(productSnap.data(),productId);
        } else {
            console.log("No such document!");
        }

        const affilatorRef = doc(db, `users`, affiliatorId);
        const affilatorSnap = await getDoc(affilatorRef);

        if (affilatorSnap.exists()) {
            setAffiliator(affilatorSnap.data());
            setIsAffiliator(true);
        } else {
            console.log("No such document!");
        }

        setLoading(false);
    }

    const handleSubmitOrder = async () => {
        handlingCookie();        
        const userData=Cookies.get("uuid");
        const expiredDate= Cookies.get("expired_date");
        const userID= Cookies.get("uid");
        if(expiredDate === undefined){
            return toast({
                title: "Message",
                description: "Refresh this page and try again. Sorry, there was a problem with the form,or the link you followed has expired.",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top",
            });

        }
        const todayDate=new Date().toISOString().slice(0,10);
        const endDate=new Date(expiredDate).toISOString().slice(0,10);
        if(todayDate > endDate){
            return toast({
                title: "Message",
                description: `The Link you followed has expired. (Expired Date : ${endDate})`,
                status: "info",
                duration: 9000,
                variant: 'subtle',
                isClosable: true,
                position: "top",
            });
        }
        setIsSubmited(true);
        let responseData=[];
        const result=myNetwork(function(values) {
            responseData.push(values);
          }).finally(()=>{
            // console.log(responseData[0]['ip'],'DONE!');
          //start tracking
          const appId=product['appId'];
          const token=product['appKey'];
          let data=JSON.stringify({
            "app_id": appId,
            "track": "InitiateCheckout",
            "pathname": window.location.pathname,
            "browser": getBrowserName(),
            "userAgent": window.navigator.userAgent,
            "type": null,
            "data": JSON.stringify(product),
            "href": window.location.href,
            "origin": window.location.origin,
            "hostname": window.location.hostname,
            "element": null,
            "host": window.location.host,
            "search": "",
            "query": "track=InitiateCheckout",
            "network": responseData[0]['ip'],
            "networkisp": responseData[0]['isp'],
            "latitude": responseData[0]['latitude'],
            "longitude": responseData[0]['lognitude'],
            "custom" : "",
            "uid" : userData,
            "expired_date" : expiredDate,
            "affiliator_id" : userID
        });
    
        var config = {
          method: 'post',
          url: `${process.env.REACT_APP_TRACKER_BASEURL}/data/${appId}`,
          headers: { 
            'Authorization': token, 
            'Content-Type': 'application/json'
          },
          data : data
        };
        axios(config)
        //end tracking          
          });
          //code

        const orderId = Math.random().toString(36).substring(6);
        const external_id = `AFL-${orderId}-${moment().format('YYYYMMDDHHmmss')}`;
        const totalAmount = Number(product.productPrice) * value;

        try {
            const docRef = await setDoc(doc(db, "orders", external_id), {
                orderId: external_id,
                productId: productId,
                brandId: brandId,
                affiliatorId: affiliatorId,
                productData: product,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                customerName: customerName,
                customerEmail: customerEmail,
                customerPhone: customerPhone,
                quantity: value,
                amount: totalAmount,
                status: "pending",
                timestamp: serverTimestamp(),
                uid:userData,
                expired_date : expiredDate
            });

            // console.log("docRef - checkpoint 1");

            const invoiceData = JSON.stringify({
                external_id: external_id,
                amount: totalAmount,
                description: `Invoice to ${customerName} for purchasing ${product.productTitle} from ${product.brandName} at ${moment().format('YYYY-MM-DD HH:mm:ss')}`,
                invoice_duration: 86400,
                success_redirect_url: `${window.location.protocol + '//' + window.location.host + '/payment/callback'}?status=success&external_id=${external_id}&uuid=${userData}`,
                failure_redirect_url: `${window.location.protocol + '//' + window.location.host + '/payment/callback'}?status=failure&external_id=${external_id}&uuid=${userData}`,
            });

            // console.log(invoiceData, "invoiceData - checkpoint 2");

            const createXenditInvoice = await createInvoice('stage', invoiceData);

            // console.log(createXenditInvoice, "createXenditInvoice - checkpoint 3");

            const xenditRef = await setDoc(doc(db, `orders/${external_id}/invoices`, external_id), {
                createXenditInvoice
            });

            // console.log(xenditRef, "xenditRef - checkpoint 4");

            const invoiceUrl = createXenditInvoice.invoice_url;

            toast({
                title: "Order created.",
                description: "We've created your order for you.",
                status: "success",
                duration: 9000,
                isClosable: true,
                position: "top",
            });

            window.location.href = invoiceUrl;
        } catch (e) {
            console.error("Error adding document: ", e);
            toast({
                title: "Order failed.",
                description: "We've failed to create your order.",
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            setIsSubmited(false);
        }
    };

    const QuantityPicker = (props) => {
        const { min = 1, max, rootProps } = props
        // console.log(value, "value");

        const handleDecrement = () => {
            setValue(value === min ? value : value - 1);
        }

        const handleIncrement = () => {
            setValue(value === max ? value : value + 1);
        }

        return (
            <FormControl {...rootProps} isDisabled>
                <FormLabel>
                    Jumlah Pesanan
                </FormLabel>
                <Flex
                    borderRadius="base"
                    px="2"
                    py="0.4375rem"
                    borderWidth="1px"
                    justifyContent="space-between"
                >
                    <QuantityPickerButton
                        onClick={handleDecrement}
                        icon={<FiMinus />}
                        isDisabled={value === min}
                        aria-label="Decrement"
                    />
                    <Center minW="8">
                        <Text as="span" fontWeight="semibold" userSelect="none">
                            {value}
                        </Text>
                    </Center>
                    <QuantityPickerButton
                        onClick={handleIncrement}
                        icon={<FiPlus />}
                        isDisabled={value === max}
                        aria-label="Increment"
                    />
                </Flex>
            </FormControl>
        )
    }

    useEffect(() => {
        handleGetProductData();
    }, [])


    return (
        <Container maxW='90%' pt="10" mb="5" p={{
            base: "0",
        }}>
            {isProduct && isBrand && isAffiliator && !loading ? (
                <Center mb="10" p={{
                    base: "0",
                    md: "10",
                }}>
                    <Box
                        maxW="90%"
                        mx="auto"
                        px={{
                            base: '0',
                            md: '8',
                            lg: '12',
                        }}
                        py={{
                            base: '4',
                            md: '8',
                            lg: '12',
                        }}
                        justifyContent="center"
                    >
                        <Stack
                            direction={{
                                base: 'column',
                                lg: 'column',
                            }}
                            spacing={{
                                base: '6',
                                lg: '12',
                                xl: '16',
                            }}
                            justifyContent="space-between"
                        >
                            <Center><Badge variant='outline' colorScheme='blue'>EXPIRED DATE : {Cookies.get("expired_date")? Cookies.get("expired_date") : null}</Badge></Center>
                            <Center>
                                {isImageLoading ? (
                                    <Skeleton
                                        height={{
                                            base: '300px',
                                            lg: 'md',
                                        }}
                                        width={{
                                            base: '300px',
                                            lg: 'md',
                                        }}
                                        borderRadius="lg"
                                    />
                                ) : (
                                    <Gallery
                                        rootProps={{
                                            overflow: 'hidden',
                                            flex: '1',
                                        }}
                                        images={productImg.slice(0, 5)}
                                    />
                                )}
                            </Center>

                            <Stack
                                spacing={{
                                    base: '6',
                                    lg: '8',
                                }}
                                maxW={{
                                    lg: 'xl',
                                }}
                                justify="center"
                            >
                                <Stack
                                    spacing={{
                                        base: '3',
                                        md: '4',
                                    }}
                                >
                                    <Stack spacing="3">
                                        <Badge colorScheme='green' maxW={"min"}>{product.productCategory}</Badge>
                                        <Heading size="lg" fontWeight="medium">
                                            {product.productTitle}
                                        </Heading>
                                    </Stack>
                                    <PriceTag
                                        price={product.productPrice}
                                        currency="IDR"
                                        rootProps={{
                                            fontSize: '2xl',
                                        }}
                                    />
                                    <Text color={'gray.600'}>
                                        {product.productDescription}
                                    </Text>
                                    {
                                        product['productType'] === "physical" ?
                                        <>
                                        <ProductVariant data={product.productVariant}/>
                                        <ProductDimension data={product}/>
                                        </>
                                        :
                                        null
                                    }
                                </Stack>

                                <HStack
                                    spacing={{
                                        base: '4',
                                        md: '8',
                                    }}
                                    align="flex-end"
                                    justify="space-evenly"
                                >
                                    <Box flex="1">
                                        <QuantityPicker max={product.maxQty === undefined ? 0 : product.maxQty} />
                                    </Box>
                                </HStack>

                                <FormControl isRequired>
                                    <FormLabel htmlFor="name">Nama Pemesan</FormLabel>
                                    <Input
                                        id="customerName"
                                        type="text"
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel htmlFor="name">Email Pemesan</FormLabel>
                                    <Input
                                        id="customerEmail"
                                        type="text"
                                        onChange={(e) => setCustomerEmail(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel htmlFor="name">No Handphone Pemesan</FormLabel>
                                    <Input
                                        id="customerEmail"
                                        type={"number"}
                                        onChange={(e) => setCustomerPhone(e.target.value)}
                                    />
                                </FormControl>

                                <Button id="buy" isDisabled={isSubmited ? true : false} colorScheme="green" size="lg" onClick={() => handleSubmitOrder()}>
                                    {isSubmited ? (
                                        <>
                                            <Spinner /> <Text ml="2">Pesanan Sedang Diproses...</Text>
                                        </>
                                    ) : "Pesan Sekarang"}
                                </Button>
                            </Stack>
                            <Divider mt={5} mb={5} />
                            <Center>
                                <Image w={'300px'} src={'/safe-checkout.jpeg'} alt="Affiliator" />
                            </Center>
                        </Stack>
                    </Box>
                </Center>) : (
                <Center>
                    <Spinner />
                </Center>
            )}
        </Container>
    )
}

// All Below This Are Product Detail Components
// ================start here===================== //

const Gallery = (props) => {
    const { images, aspectRatio = 1 / 1, rootProps } = props
    const [currentSlide, setCurrentSlide] = React.useState(0)
    const [ref, slider] = useCarousel({
        slideChanged: (slider) => setCurrentSlide(slider.track.details.rel),
    })
    const hasPrevious = currentSlide !== 0
    const hasNext = currentSlide < images.length - 1
    return (
        <Stack
            maxW={{
                base: '100%',
                lg: 'xl',
            }}
            rounded="lg"
            spacing="4"
            {...rootProps}
        >
            <Box
                position="relative"
                sx={{
                    _hover: {
                        '> button': {
                            display: 'inline-flex',
                        },
                    },
                }}
            >
                <Carousel ref={ref}>
                    {images.map((image, i) => (
                        <CarouselSlide key={i}>
                            <AspectRatio
                                ratio={aspectRatio}
                                transition="all 200ms"
                                opacity={currentSlide === i ? 1 : 0.4}
                                _hover={{
                                    opacity: 1,
                                }}
                            >
                                <Image src={image.src} objectFit="cover" alt={image.alt} fallback={<Skeleton />} />
                            </AspectRatio>
                        </CarouselSlide>
                    ))}
                </Carousel>
                {hasPrevious && (
                    <CarouselIconButton
                        pos="absolute"
                        left="3"
                        top="50%"
                        transform="translateY(-50%)"
                        onClick={() => slider.current?.prev()}
                        icon={<IoChevronBackOutline />}
                        aria-label="Previous Slide"
                    />
                )}

                {hasNext && (
                    <CarouselIconButton
                        pos="absolute"
                        right="3"
                        top="50%"
                        transform="translateY(-50%)"
                        onClick={() => slider.current?.next()}
                        icon={<IoChevronForwardOutline />}
                        aria-label="Next Slide"
                    />
                )}
                <HStack position="absolute" width="full" justify="center" bottom="0" py="4">
                    {images.map((_, index) => (
                        <Circle key={index} size="2" bg={currentSlide === index ? 'white' : 'whiteAlpha.400'} />
                    ))}
                </HStack>
            </Box>
        </Stack>
    )
}

const CarouselIconButton = (props) => (
    <IconButton
        display="none"
        fontSize="lg"
        isRound
        boxShadow="base"
        bg={useColorModeValue('white', 'gray.800')}
        _hover={{
            bg: useColorModeValue('gray.100', 'gray.700'),
        }}
        _active={{
            bg: useColorModeValue('gray.200', 'gray.600'),
        }}
        _focus={{
            boxShadow: 'inerhit',
        }}
        _focusVisible={{
            boxShadow: 'outline',
        }}
        {...props}
    />
)

const Carousel = React.forwardRef(function Carousel(props, ref) {
    return (
        <Flex
            ref={ref}
            className="chakra-carousel"
            overflow="hidden"
            position="relative"
            userSelect="none"
            {...props}
        />
    )
})

const CarouselSlide = (props) => (
    <Box
        className="chakra-carousel__slide"
        position="relative"
        overflow="hidden"
        width="100%"
        minH="100%"
        {...props}
    />
)

const useCarousel = (options) => {
    const defaultOptions = {
        selector: '.chakra-carousel__slide',
    }
    return useKeenSlider({ ...defaultOptions, ...options })
}

const QuantityPickerButton = (props) => (
    <IconButton
        isDisabled
        size="sm"
        fontSize="md"
        _focus={{
            boxShadow: 'none',
        }}
        _focusVisible={{
            boxShadow: 'outline',
        }}
        {...props}
    />
)

function formatPrice(value, opts = {}) {
    const { locale = 'en-US', currency = 'USD' } = opts
    const formatter = new Intl.NumberFormat(locale, {
        currency,
        style: 'currency',
        maximumFractionDigits: 2,
    })
    return formatter.format(value)
}

const PriceTag = (props) => {
    const { price, currency, salePrice, rootProps, priceProps, salePriceProps } = props
    return (
        <HStack spacing="1" {...rootProps}>
            <Price isOnSale={!!salePrice} textProps={priceProps}>
                {formatPrice(price, {
                    currency,
                })}
            </Price>
            {salePrice && (
                <SalePrice {...salePriceProps}>
                    {formatPrice(salePrice, {
                        currency,
                    })}
                </SalePrice>
            )}
        </HStack>
    )
}

const Price = (props) => {
    const { isOnSale, children, textProps } = props
    const defaultColor = mode('gray.700', 'gray.400')
    const onSaleColor = mode('gray.400', 'gray.700')
    const color = isOnSale ? onSaleColor : defaultColor
    return (
        <Text
            as="span"
            fontWeight="medium"
            color={color}
            textDecoration={isOnSale ? 'line-through' : 'none'}
            {...textProps}
        >
            {children}
        </Text>
    )
}

const SalePrice = (props) => (
    <Text as="span" fontWeight="semibold" color={mode('gray.800', 'gray.100')} {...props} />
)

// ==================end here=================== //

export default ProductPage